import type { IToastMessagePrv } from '../state/interface';
import { classNameForElement, StyleElement } from './AllMessages.style';
import Message from './Message';

function AllMessages(props: { messages: IToastMessagePrv[] }): JSX.Element {
    const className = (elem: StyleElement) => classNameForElement(elem);

    if (props.messages.length <= 0) {
        /* eslint-disable-next-line react/jsx-no-useless-fragment */
        return <></>;
    }

    return (
        <div role="complementary" className={className(StyleElement.Container)}>
            {props.messages.map(item => (
                <Message key={item.id} {...item} />
            ))}
        </div>
    );
}

export default AllMessages;
